import { SideImage } from '../../components/SideImage';
import { PageSection } from '../../components/Section';
import { SkeletonCard, SkeletonRow } from '../../components/SkeletonCard';
import { DesktopOnly, MobileOnly } from '../../components/Layout';
import { ContentPanel } from '../../composites/ContentPanel';
import { SplitLayout } from '../../composites/SplitLayout';
import type { SpaDayDetailTemplateProps } from './SpaDayDetailTemplate.types';

export function SpaDayDetailTemplate({
  imageUrl,
  imageAlt,
  title,
  price,
  discount,
  priceLabel,
  promotionName,
  categoryLabel,
  description,
  termsContent,
  termsLabel,
  onReserve,
  reserveLabel,
  onBack,
  viewAllLabel,
  telephoneOnly,
  unavailable,
  recommendations,
  isLoading,
  journeyBar,
}: SpaDayDetailTemplateProps) {
  const showRecommendations = isLoading || !!recommendations;

  return (
    <>
      <SplitLayout
        left={
          <SideImage
            src={imageUrl}
            alt={imageAlt}
            sticky
            onBack={onBack}
            backLabel={viewAllLabel}
            overlayContent={journeyBar ? <MobileOnly>{journeyBar}</MobileOnly> : undefined}
          />
        }
        right={
          <>
            {journeyBar && <DesktopOnly>{journeyBar}</DesktopOnly>}
            <ContentPanel
              title={title}
              price={price}
              discount={discount}
              priceLabel={priceLabel}
              promotionName={promotionName}
              categoryLabel={categoryLabel}
              description={description}
              termsContent={termsContent}
              termsLabel={termsLabel}
              onReserve={telephoneOnly || unavailable ? undefined : onReserve}
              reserveLabel={reserveLabel}
              isLoading={isLoading}
              telephoneOnly={telephoneOnly}
              unavailable={
                !telephoneOnly && unavailable
                  ? { ...unavailable, onCtaClick: unavailable.onCtaClick ?? onBack }
                  : undefined
              }
            />
          </>
        }
      />

      {showRecommendations && (
        <PageSection>
          {isLoading ? (
            <SkeletonRow>
              {Array.from({ length: 4 }).map((_, i) => (
                <SkeletonCard key={i} variant="grid" />
              ))}
            </SkeletonRow>
          ) : (
            recommendations
          )}
        </PageSection>
      )}
    </>
  );
}
